import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import Chart from "pro-features/components/Chart/src/Chart";

import { MarketingChannelsLoader } from "../common/MarketingChannelsLoader";
import { MarketingChannelsNoData } from "../common/MarketingChannelsNoData";
import { useMarketingChannelsServices } from "../common/useMarketingChannelsServices";

import type { ApiTotalData } from "./types";
import { getChartConfig } from "./utils/chartConfig";
import { adaptApiData, sortChartData } from "./utils/chartDataAdapter";

interface ITrafficShareBarChart {
    isLoading: boolean;
    apiData: ApiTotalData;
}

export const TrafficShareBarChart = ({ isLoading, apiData }: ITrafficShareBarChart) => {
    const { services } = useMarketingChannelsServices();

    const data = useMemo(() => {
        if (apiData) {
            const adaptedData = adaptApiData(apiData, services);
            const sortedData = sortChartData(adaptedData);
            return sortedData;
        }
    }, [isLoading, apiData]);

    const chartConfig = useMemo(() => {
        if (!data) {
            return null;
        }
        return getChartConfig(data, services);
    }, [data, services]);

    if (isLoading) {
        return (
            <Flex
                alignItems="center"
                justifyContent="center"
            >
                <MarketingChannelsLoader />
            </Flex>
        );
    }

    if (!data) {
        return <MarketingChannelsNoData services={services} />;
    }

    return (
        <Chart
            type="column"
            data={[data]}
            config={chartConfig}
        />
    );
};
